import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { InvoiceStore, InvoiceDTO, InvoiceSearchParams } from '../types';

const initialState = {
    invoices: [] as InvoiceDTO[],
    selectedInvoice: null as InvoiceDTO | null,
    totalElements: 0,
    currentPage: 0,
    pageSize: 20,
    isLoading: false,
    isSubmitting: false,
    error: null as string | null,
    searchParams: {} as InvoiceSearchParams
};

export const useInvoiceStore = create<InvoiceStore>()(
    devtools(
        (set) => ({
            ...initialState,
            setInvoices: (invoices, total) => set({ invoices, totalElements: total }),
            setSelectedInvoice: (invoice) => set({ selectedInvoice: invoice }),
            setCurrentPage: (page) => set({ currentPage: page }),
            setPageSize: (size) => set({ pageSize: size }),
            setLoading: (loading) => set({ isLoading: loading }),
            setSubmitting: (submitting) => set({ isSubmitting: submitting }),
            setError: (error) => set({ error }),
            setSearchParams: (params) => set({ searchParams: params }),
            reset: () => set(initialState)
        }),
        { name: 'invoice-store' }
    )
);
